const env = process.env.REACT_APP_TARGET_ENV || 'local';

const config = {
  env,
  isLocal: env === 'local',
  isDevelopment: env === 'development',
  isProduction: env === 'production',
  isStaging: env === 'staging',
  isDemo: env === 'demo',
  isSimulation: env === 'simulation',

  // Firebase auth emulator, only for envs listed here (null = real Firebase).
  // REACT_APP_FIREBASE_AUTH_EMULATOR_URL overrides the URL for those envs.
  firebaseAuthEmulatorUrl: (() => {
    const defaultUrl = {
      local: 'http://localhost:9099',
      simulation: 'https://firebase.vibecloser.com/',
    }[env];
    return defaultUrl
      ? process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_URL || defaultUrl
      : null;
  })(),

  apiBaseUrl: {
    local: 'http://localhost:5058/api/',
    development: 'https://app.sellingbees.com/api/',
    production: 'https://app.qualification.ai/api/',
    // TODO: replace with the simulation API host
    simulation: 'https://api.vibecloser.com/api/',
  }[env],

  actionCodeBaseUrl: {
    local: 'https://localhost:3000/',
    development: 'https://app.sellingbees.com/',
    production: 'https://app.dealcopilot.ai/',
    // TODO: replace with the simulation app host
    simulation: 'https://demo.vibecloser.com',
  }[env],

  mcpConnectorBaseUrl: {
    local: 'https://app.sellingbees.com/',
    development: 'https://app.sellingbees.com/',
    production: 'https://api.dealcopilot.ai/',
    // TODO: replace with the simulation MCP connector host
    simulation: 'https://demo.vibecloser.com/',
  }[env],

  notificationApiBaseUrl:
    {
      development: 'http://localhost:9090/api/n/',
      staging: 'https://app.introx.app/api/n/',
      demo: 'https://demo.ing.express/api/n/',
      production: 'https://app.hiring.express/api/n/',
      simulation: 'https://api.vibecloser.com/api/n',
    }[env] || '',

  firebaseConfig:
    {
      local: {
        apiKey: 'AIzaSyClsAtMF6rHhoNWgYfBigX35fcIs0Zojwg',
        authDomain: 'app-dev-381401.firebaseapp.com',
        projectId: 'app-dev-381401',
        storageBucket: 'app-dev-381401.appspot.com',
        messagingSenderId: '1090205382087',
        appId: '1:1090205382087:web:a0a74e4cf2c15073b515e2',
      },
      development: {
        apiKey: 'AIzaSyClsAtMF6rHhoNWgYfBigX35fcIs0Zojwg',
        authDomain: 'app-dev-381401.firebaseapp.com',
        projectId: 'app-dev-381401',
        storageBucket: 'app-dev-381401.appspot.com',
        messagingSenderId: '1090205382087',
        appId: '1:1090205382087:web:a0a74e4cf2c15073b515e2',
      },
      // Simulation shares the dev Firebase project until it gets its own.
      simulation: {
        apiKey: 'AIzaSyClsAtMF6rHhoNWgYfBigX35fcIs0Zojwg',
        authDomain: 'app-dev-381401.firebaseapp.com',
        projectId: 'app-dev-381401',
        storageBucket: 'app-dev-381401.appspot.com',
        messagingSenderId: '1090205382087',
        appId: '1:1090205382087:web:a0a74e4cf2c15073b515e2',
      },
      production: {
        apiKey: 'AIzaSyDmiC0R8jEqkIQnn83iqEm-Av3TirPCBr4',
        authDomain: 'app-prod-383715.firebaseapp.com',
        projectId: 'app-prod-383715',
        storageBucket: 'app-prod-383715.appspot.com',
        messagingSenderId: '14575999557',
        appId: '1:14575999557:web:62787b4c543335f399212c',
        measurementId: 'G-WDEYED32JP',
      },
    }[env] || {},

  pusher: {
    key:
      {
        local: '09c641d72e57f47efd7d',
        development: '63a45dbb9aca3dd3c2e9',
        production: '10423203228d4e2efe1f',
        // Simulation shares the dev Pusher app until it gets its own.
        simulation: '63a45dbb9aca3dd3c2e9',
      }[env] || '',
    cluster: env === 'development' || env === 'simulation' ? 'us2' : 'ap2',
  },
  openReplay: {
    projectKey: 'OchCWFYOg6bErjB3RXHQ',
  },
};

export default config;
